module.exports = __webpack_public_path__ + "static/media/09.5774f367.png";